module.exports = __webpack_public_path__ + "img/unlocked.831d461a.png";